export default __webpack_public_path__ + "static/media/pornhub-comment-bg.5eda3d3d.png";